import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import PropertyDocument from "../components/PropertyDetalis/PropertyDocument";
import PropertyImages from "../components/PropertyDetalis/PropertyImages";
import RecentPropertiesList from "../components/RecentProperties/RecentPropertiesList";
import Loader from "../components/common/Loader";
import { api, investorApi, vendorApi } from "../api/api";
import { updateReferrerId } from "../redux/reducers/Reducer";
import ScreenContainer from "../components/common/screencontainer";
import Description from "../components/common/Description";

import { useParams, useLocation } from "react-router-dom";




const PropertyDetailsScreen = () => {
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { slug } = useParams();
  const location = useLocation();

  const query = decodeURIComponent(location.search.slice(1));

  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get("ref");

  let propertyId = null;

  if (slug) {
    const parts = slug.split("-");
    propertyId = parts[parts.length - 1];


  }

  // let property_code = null;
  // let reffer_code = null;

  // if (query) {
  //   const parts = query.split('/');
  //   if (parts.length === 2) {
  //     property_code = parts[0];
  //     reffer_code = parts[1];
  //   } else if (parts.length === 1) {
  //     property_code = parts[0];
  //   }
  // }

  // console.log(property_code ,reffer_code );


  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // if (!property_code && !reffer_code) return;

    const getPropertyAndFetchDetails = async () => {
      try {
        // const { data } = await api.getPropertyId(
        //   // property_code || null,
        //   // reffer_code || null
        //   propertyId , referralCode
        // );

        // const propertyId = data?.propertyId;
        // const ReffererId = data?.userId;

        // if (!propertyId) {
        //   console.warn("No propertyId returned from backend");
        //   return;
        // }

        // if (ReffererId) {
        //   dispatch(updateReferrerId({ ReffererId }));
        //   localStorage.setItem("referrerId", ReffererId);
        // }

        // if (
        //   isAuthenticated &&
        //   userId &&
        //   referralCode &&
        //   userId !== parseInt(referralCode)
        // ) {
        //   const fd = new FormData();
        //   fd.append("userId", userId);
        //   fd.append("refererId", referralCode);
        //   fd.append("propertyId", propertyId);

        //   await vendorApi.addProjectUserMapping(fd);
        // }

        const response = await investorApi.getPropertyDetails(propertyId);

        if (response.status === 200) {
          const normalizedData = Array.isArray(response.data)
            ? response.data
            : [response.data];

          setPropertyData(normalizedData);
        }

      } catch (err) {
        console.error(
          "Error fetching property details:",
          err?.response?.data || err.message || err
        );
      } finally {
        setLoading(false);
      }
    };

    getPropertyAndFetchDetails();
  }, [
    // property_code, reffer_code,
    propertyId, referralCode,
    isAuthenticated, userId]);

  const layoutConfig = [
    {
      id: "PropertyImages",
      render: () => <PropertyImages data={propertyData} />,
    },
    {
      id: "PropertyDescription",
      render: () => <Description data={propertyData} />,
    },
    ...(propertyData?.[0]?.Status === "sale Initiated" ||
      propertyData?.[0]?.Status === "Sold"
      ? [
        {
          id: "PropertyDocument",
          render: () => (
            <PropertyDocument
              data={propertyData?.[0]?.id}
              userId={userId}
              type={propertyData?.[0]?.type}
            />
          ),
        },
      ]
      : []),
    ...(propertyData?.[0]?.Status !== "sale Initiated" &&
      propertyData?.[0]?.Status !== "Sold"
      ? [
        {
          id: "RecentProperties",
          render: () => (
            <RecentPropertiesList
              userId={userId}
              type={propertyData?.[0]?.type}
              propertyId={propertyData?.[0]?.id}
            />
          ),
        },
      ]
      : []),
  ];

  return (
    <ScreenContainer>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          padding: "5px"
        }}>
          {layoutConfig.map((section) => (
            <div key={section.id} style={styles.section}>
              {section.render()}
            </div>
          ))}
        </Box>
      )}
    </ScreenContainer>
  );
};

const styles = {
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  section: {},
};

export default PropertyDetailsScreen;